<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
  },
}
</script>

<template>
  <VTabItem>
    <slot />
  </VTabItem>
</template>
